import { render, staticRenderFns } from "./debtRanking.vue?vue&type=template&id=1a78aed6"
import script from "./debtRanking.vue?vue&type=script&lang=js"
export * from "./debtRanking.vue?vue&type=script&lang=js"
import style0 from "./debtRanking.vue?vue&type=style&index=0&id=1a78aed6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports